var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateLabels = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.223 219.771L247.172 134.607C245.763 132.486 246.123 129.768 247.975 128.538L281.951 105.974C283.803 104.744 286.451 105.465 287.859 107.585L345.119 193.064C347.267 196.297 345.174 200.26 341.628 199.68L320.131 196.167C318.093 195.835 316.299 197.069 315.876 199.097L311.703 219.001C310.95 222.591 306.404 223.059 304.222 219.774L304.223 219.771Z",
    fill: "white",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.426 100.701C282.514 100.334 283.707 100.454 284.701 101.028L366.276 148.125C368.189 149.229 368.845 151.676 367.74 153.589L346.51 190.359C345.406 192.273 342.96 192.928 341.046 191.823L259.472 144.726C258.478 144.152 257.778 143.179 257.551 142.053L251.952 114.307C251.553 112.331 252.687 110.367 254.597 109.725L281.426 100.701Z",
    fill: "white",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.132 135.433L149.239 138.413L135.352 141.392L121.456 144.375L110.636 146.695L103.65 114.136L45.895 126.529L52.884 159.088L59.8699 191.646L66.8558 224.205L124.608 211.813L182.36 199.424L240.115 187.031L233.129 154.472L226.143 121.913L219.157 89.3545L161.402 101.747L167.261 129.05",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.455 72.1238L42.1987 109.298L45.8959 126.529L219.152 89.3549L215.455 72.1238Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.771 172.232L146.573 185.577L148.418 194.176L210.616 180.83L208.771 172.232Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8558 224.205L45.8979 126.528L27.9424 130.381L48.9003 228.057L66.8558 224.205Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.652 114.137L45.8989 126.529L66.8568 224.205L124.61 211.814L103.652 114.137Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.132 135.433L149.239 138.412L135.352 141.392L121.455 144.375L110.636 146.695L112.956 157.518L115.939 171.408L117.622 179.254L124.607 211.813L182.359 199.423L179.791 187.442L177.945 178.843L175.374 166.865L173.223 156.833L170.243 142.943L168.388 134.306L167.261 129.05",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.153 89.3553L161.4 101.747L182.358 199.423L240.111 187.032L219.153 89.3553Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.652 114.139L45.8989 126.531L52.8849 159.09L110.638 146.698L103.652 114.139Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.132 135.433L168.388 134.306L226.143 121.913L219.157 89.3545L161.402 101.747L167.261 129.05",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.142 121.912L52.8823 159.087L59.8683 191.646L233.128 154.471L226.142 121.912Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240.113 187.031L233.127 154.472L59.8712 191.647L66.8572 224.205L240.113 187.031Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2488 142.422C90.4563 137.462 89.0356 130.841 84.0757 127.633C79.1157 124.426 72.4947 125.846 69.2872 130.806C66.0797 135.766 67.5003 142.387 72.4603 145.595C77.4202 148.802 84.0413 147.382 87.2488 142.422Z",
    fill: "#4767FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.495 156.701L164.755 168.393",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.644 143.423L151.186 171.304",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.739 136.265L137.612 174.218",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.166 139.179L124.045 177.128",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6 142.089L116.529 170.893",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.03 145L113.678 157.615",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M281.251 127.282C280.024 130.673 275.848 131.744 273.141 129.357C271.628 128.026 271.069 125.838 271.757 123.944C272.984 120.554 277.16 119.483 279.867 121.869C281.38 123.2 281.939 125.389 281.251 127.282Z",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M212.451 85.9413C212.451 85.9413 224.303 71.2443 240.498 72.5567C262.083 74.3023 257.722 105.973 245.741 100.359C233.791 94.7576 253.135 68.2521 271.11 70.0292C290.74 71.9727 288.527 100.262 275.139 129.5",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.6392,
    y: 166,
    width: 63,
    height: 63,
    rx: 14,
    fill: "#4767FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.962 183.455C113.962 185.571 112.248 187.286 110.132 187.286C108.017 187.286 106.302 185.571 106.302 183.455C106.302 181.34 108.017 179.625 110.132 179.625C112.248 179.625 113.962 181.34 113.962 183.455Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.962 211.545C113.962 213.66 112.248 215.375 110.132 215.375C108.017 215.375 106.302 213.66 106.302 211.545C106.302 209.429 108.017 207.714 110.132 207.714C112.248 207.714 113.962 209.429 113.962 211.545Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.291 194.118C122.435 195.134 120.107 194.452 119.092 192.597C118.076 190.741 118.758 188.413 120.613 187.398C122.469 186.382 124.797 187.063 125.812 188.919C126.828 190.775 126.147 193.103 124.291 194.118Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6498 207.602C97.794 208.618 95.4664 207.936 94.4509 206.081C93.4354 204.225 94.1166 201.897 95.9723 200.882C97.8281 199.866 100.156 200.547 101.171 202.403C102.187 204.259 101.506 206.587 99.6498 207.602Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9723 194.118C97.8281 195.134 100.156 194.452 101.171 192.597C102.187 190.741 101.506 188.413 99.6497 187.398C97.794 186.382 95.4663 187.063 94.4508 188.919C93.4353 190.775 94.1165 193.103 95.9723 194.118Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.614 207.602C122.47 208.618 124.797 207.936 125.813 206.081C126.828 204.225 126.147 201.897 124.291 200.882C122.436 199.866 120.108 200.547 119.092 202.403C118.077 204.259 118.758 206.587 120.614 207.602Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.132 188.863C111.029 188.863 111.757 189.59 111.757 190.488V204.512C111.757 205.409 111.029 206.137 110.132 206.137C109.234 206.137 108.507 205.409 108.507 204.512V190.488C108.507 189.59 109.234 188.863 110.132 188.863Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.612 193.182C118.061 193.959 117.795 194.953 117.018 195.401L104.872 202.413C104.095 202.862 103.101 202.596 102.653 201.819C102.204 201.041 102.47 200.048 103.247 199.599L115.393 192.587C116.17 192.138 117.164 192.404 117.612 193.182Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.612 201.818C117.164 202.596 116.17 202.862 115.393 202.413L103.247 195.401C102.47 194.952 102.204 193.959 102.653 193.181C103.101 192.404 104.095 192.138 104.872 192.587L117.018 199.599C117.795 200.047 118.061 201.041 117.612 201.818Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M332.553 151.071C324.053 153.146 322.02 155.716 320.579 167.486C320.492 168.171 319.508 168.171 319.423 167.486C317.984 155.712 315.947 153.146 307.447 151.071C306.851 150.927 306.851 150.072 307.447 149.928C315.947 147.853 317.98 145.284 319.423 133.514C319.508 132.829 320.492 132.829 320.579 133.514C322.016 145.288 324.053 147.853 332.553 149.928C333.149 150.072 333.149 150.927 332.553 151.071Z",
    fill: "#4767FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M217.906 237.304C218.349 235.423 217.184 233.538 215.304 233.095C213.423 232.65 211.538 233.816 211.094 235.697C210.651 237.577 211.816 239.462 213.696 239.905C215.577 240.35 217.462 239.184 217.906 237.304Z",
    fill: "#071A24"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M322.962 68.8442C323.153 68.0381 322.653 67.2306 321.846 67.0404C321.039 66.8502 320.231 67.3498 320.04 68.1559C319.85 68.9619 320.35 69.7694 321.156 69.9596C321.963 70.1498 322.772 69.6502 322.962 68.8442Z",
    fill: "#071A24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M211.946 34.4566C212.2 33.3828 211.534 32.3071 210.458 32.0538C209.385 31.8005 208.307 32.4659 208.054 33.5397C207.8 34.6135 208.466 35.6891 209.54 35.9424C210.615 36.1958 211.693 35.5303 211.946 34.4566Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateLabels);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateLabels.695a2f55fe20de2c580ad271c0898aa7.svg";